<h1 *ngIf="!isLoaded && !error" class="px-2 mx-auto">Loading...</h1>
<h1 *ngIf="error" class="px-2 mx-auto text-red-500">{{ error.toString() }}</h1>

<section *ngIf="isLoaded && scan" class="flex flex-col justify-center mx-auto">
  <div class="flex flex-row flex-wrap p-1 m-2 mb-2 text-left border border-gray-800 border-solid">
    <span class="flex-grow bg-gray-800"></span>
    <span class="p-1 ml-1 bg-gray-800 border border-gray-800 border-solid">Teleskop-Report</span>
    <span class="p-1 ml-1 bg-gray-800 border border-gray-800 border-solid">System</span>
    <span class="w-20 p-1 mr-1 text-center bg-black border border-gray-800 border-solid">{{ scan.x }}|{{ scan.y }}</span>
    <span class="p-1 bg-gray-800 border border-gray-800 border-solid">Objekte</span>
    <span class="w-16 p-1 mr-1 text-center bg-black border border-gray-800 border-solid">{{ scan.scanObjects.length }}</span>
    <span class="p-1 bg-gray-800 border border-gray-800 border-solid">Aktualisiert am</span>
    <span class="p-1 bg-black border border-gray-800 border-solid">{{ scan.updatedAt | date:'dd.MM.yyyy HH:mm' }}</span>
    <span class="p-1 bg-gray-800 border border-gray-800 border-solid">von</span>
    <span class="p-1 mr-1 bg-black border border-gray-800 border-solid">
      <a [routerLink]="['/admin/user', scan.updatedBy.id]" class="hover:text-orange-300">{{ scan.updatedBy.name }}</a>
    </span>
    <span class="p-1 bg-gray-800 border border-gray-800 border-solid">Erstellt am</span>
    <span class="p-1 bg-black border border-gray-800 border-solid">{{ scan.createdAt | date:'dd.MM.yyyy HH:mm' }}</span>
    <span class="p-1 bg-gray-800 border border-gray-800 border-solid">von</span>
    <span class="p-1 mr-1 bg-black border border-gray-800 border-solid">
      <a [routerLink]="['/admin/user', scan.createdBy.id]" class="hover:text-orange-300">{{ scan.createdBy.name }}</a>
    </span>
    <span class="flex-grow bg-gray-800"></span>
  </div>

  <table class="table mx-auto border-separate border-spacing-1">
    <thead>
      <tr>
        <th class="px-2 bg-gray-800 border border-gray-700 border-solid">Bild</th>
        <th class="px-2 bg-gray-800 border border-gray-700 border-solid">Name</th>
        <th class="px-2 bg-gray-800 border border-gray-700 border-solid">NCC</th>
        <th class="px-2 bg-gray-800 border border-gray-700 border-solid">Klasse</th>
        <th class="px-2 bg-gray-800 border border-gray-700 border-solid">Hülle</th>
        <th class="px-2 bg-gray-800 border border-gray-700 border-solid">Schilde</th>
        <th class="px-2 bg-gray-800 border border-gray-700 border-solid">Von</th>
        <th class="px-2 bg-gray-800 border border-gray-700 border-solid">Aktualisiert am</th>
        <th class="px-2 bg-gray-800 border border-gray-700 border-solid">Aktualisiert von</th>
        <th class="px-2 bg-gray-800 border border-gray-700 border-solid">Erstellt am</th>
        <th class="px-2 bg-gray-800 border border-gray-700 border-solid">Erstellt von</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of tableRows">
        <td class="px-2 text-center bg-gray-900 border border-gray-800 border-solid">
          <img [src]="row.image" [alt]="row.objectClass" class="mx-auto" />
        </td>
        <td class="px-2 bg-gray-900 border border-gray-800 border-solid" [innerHTML]="row.name | safeHtml"></td>
        <td class="px-2 text-right bg-gray-900 border border-gray-800 border-solid">{{ row.ncc }}</td>
        <td class="px-2 text-left bg-gray-900 border border-gray-800 border-solid">{{ row.objectClass }}</td>
        <td class="px-2 text-center bg-gray-900 border border-gray-800 border-solid">{{ row.huell }}</td>
        <td class="px-2 text-center bg-gray-900 border border-gray-800 border-solid">{{ row.shields }}</td>
        <td class="px-2 bg-gray-900 border border-gray-800 border-solid">
          <a [routerLink]="['/player', row.player.id]" class="hover:text-orange-300">{{ row.player.name }}</a>
        </td>
        <td class="px-2 text-right bg-gray-900 border border-gray-800 border-solid">{{ row.updatedAt | date:'dd.MM.yyyy HH:mm' }}</td>
        <td class="px-2 text-right bg-gray-900 border border-gray-800 border-solid">
          <a [routerLink]="['/admin/user', row.updatedBy.id]" class="hover:text-orange-300">{{ row.updatedBy.name }}</a>
        </td>
        <td class="px-2 text-right bg-gray-900 border border-gray-800 border-solid">{{ row.createdAt | date:'dd.MM.yyyy HH:mm' }}</td>
        <td class="px-2 text-right bg-gray-900 border border-gray-800 border-solid">
          <a [routerLink]="['/admin/user', row.createdBy.id]" class="hover:text-orange-300">{{ row.createdBy.name }}</a>
        </td>
      </tr>
    </tbody>
  </table>
</section>
